<template>
  <div
    class="nsfw-container absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] rounded-[4px] flex items-center justify-center text-white text-xs backdrop-filter backdrop-blur-sm -mt-2"
    @click.stop
  >
    <div class="flex flex-col gap-2 items-center px-4">
      <!-- <p class="text-center">{{ i18n.global.t(`nsfw.cnBan`) }}</p> -->
      <button class="btn btn-ghost btn-sm" @click.stop="clickViewBtn">
        <i class="iconfont icon-ban" />
        {{ i18n.global.t(`Buttons.view`) }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import i18n from "@/locales";
import { isInvalidDistribution } from "@/modules/common";
import { showConfirmDialog } from "vant";

const clickViewBtn = () => {
  showConfirmDialog({
    message: i18n.global.t(
      isInvalidDistribution() ? `nsfw.iosBan` : `nsfw.cnBan`
    ),
    confirmButtonText: i18n.global.t(`Buttons.confirm`),
    showCancelButton: false,
  });
};
</script>
